import {
  Directive,
  HostListener,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { PrNumberPipe } from '../pipes/ea-number.pipe';

@Directive({
    selector: '[prMinMax]',
    standalone: false
})
export class EaMinMaxDirective implements OnInit {
  @Output() onErrorInput: any = new EventEmitter();
  @Input('min') min: number;
  @Input('max') max: number;
  @Input('fraction') fraction: number = 0;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private numberPipe: PrNumberPipe,
  ) {
    this.el = this.elementRef.nativeElement;
    this.numberPipe.transform(this.el.value, 2, false);
  }

  ngOnInit() {}

  @HostListener('focus', ['$event.target.value'])
  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    if (this.min && Number(value) < this.min) value = this.min.toString();
    if (this.max && Number(value) > this.max) value = this.max.toString();
    this.el.value = this.numberPipe.handleFraction(value, this.fraction);
  }

  @HostListener('keyup', ['$event'])
  onKeyUp($event) {
    if ($event.keyCode !== 37 && $event.keyCode !== 39) {
      let value = $event.target.value;
      let result = value.replace(/\s+/g, '').replace(/[^\d.]+/, '');

      if (this.el.value.replace(/\s+/g, '') !== result) {
        this.el.value = result;
        this.onErrorInput.emit();
      }

      if (this.el.value.length > 1 && this.el.value[0] === '0') {
        this.el.value = this.el.value.slice(1, this.el.value.length);
      }

      if (this.min && Number(this.el.value) < this.min)
        this.el.value = this.min.toString();
      if (this.max && Number(this.el.value) > this.max)
        this.el.value = this.max.toString();

      this.el.value = this.numberPipe.transform(
        result,
        this.fraction || 0,
        false,
      );
    }
  }
}
